// Module
var code = "<h2 id=\"online\">Online</h2> <p>Paying online offers numerous advantages and flexibility. </p> ";
// Exports
export default code;